import React from "react";
import { PaymentWrapper } from "./PaymentTable.styled";
import { Input, Row, Col } from "components/common";

const AddPaymentModal = (props) => {
  return (
    <PaymentWrapper>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <label htmlFor="" className="modal-label">
            Date Paid
          </label>
          <Input
            type="text"
            className="modal-input"
            value={props?.formData?.datePaid}
            onChange={(e) =>
              props.setFormData({
                ...props.formData,
                datePaid: e.target.value,
              })
            }
          />
        </Col>
        <Col span={24}>
          {" "}
          <label htmlFor="" className="modal-label">
            Install Commission
          </label>
          <Input
            type="text"
            className="modal-input"
            value={props?.formData?.installCommission}
            onChange={(e) =>
              props.setFormData({
                ...props.formData,
                installCommission: e.target.value,
              })
            }
          />
        </Col>
        <Col span={24}>
          {" "}
          <label htmlFor="" className="modal-label">
            CAP Payment
          </label>
          <Input
            type="text"
            className="modal-input"
            value={props?.formData?.CAPPayment}
            onChange={(e) => {
              props.setFormData({
                ...props.formData,
                CAPPayment: e.target.value,
              });
            }}
          />
        </Col>
        <Col span={24}>
          {" "}
          <label htmlFor="" className="modal-label">
            Clawback/Bonus
          </label>
          <Input
            type="text"
            className="modal-input"
            value={props?.formData?.clawbackBONUS}
            onChange={(e) => {
              props.setFormData({
                ...props.formData,
                clawbackBONUS: e.target.value,
              });
            }}
          />
        </Col>
        <Col span={24}>
          {" "}
          <label htmlFor="" className="modal-label">
            Total In Period
          </label>
          <Input
            type="text"
            className="modal-input"
            value={props?.formData?.totalinPeriod}
            onChange={(e) => {
              props.setFormData({
                ...props.formData,
                totalinPeriod: e.target.value,
              });
            }}
          />
        </Col>
        <Col span={24}>
          {" "}
          <label htmlFor="" className="modal-label">
            Previously Paid
          </label>
          <Input
            type="text"
            className="modal-input"
            value={props?.formData?.prevPaid}
            onChange={(e) => {
              props.setFormData({
                ...props.formData,
                prevPaid: e.target.value,
              });
            }}
          />
        </Col>
        <Col span={24}>
          {" "}
          <label htmlFor="" className="modal-label">
            Total Project Commission
          </label>
          <Input
            type="text"
            className="modal-input"
            value={props?.formData?.totalProjectCommission}
            onChange={(e) => {
              props.setFormData({
                ...props.formData,
                totalProjectCommission: e.target.value,
              });
            }}
          />
        </Col>
        <Col span={24}>
          {" "}
          <label htmlFor="" className="modal-label">
            Project
          </label>
          <Input
            type="text"
            className="modal-input"
            value={props?.formData?.projectId}
            onChange={(e) => {
              props.setFormData({
                ...props.formData,
                projectId: e.target.value,
              });
            }}
          />
        </Col>
      </Row>
    </PaymentWrapper>
  );
};

export default AddPaymentModal;
